import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeCodeState } from '~/types';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeChangeAutoLoginResponse = {
  code: string;
  message: string;
  data: {
    keepLoginStatus: TypeCodeState;
    token: {
      accessToken?: string;
      refreshToken?: string;
    };
  };
};

/** @description 자동 로그인 유지 설정 변경 */
export const useChangeAutoLogin = ({ enable }: { enable: boolean }) => {
  const { mutateAsync } = useMutation({
    mutationFn: () => {
      const isAutoLogin = enable ? 'enable' : 'disable';
      const endpoint = `/labor-accounts/keep-login/${isAutoLogin}`;
      return axiosInstance.post(endpoint);
    },
    gcTime: 0,
  });

  const requestChangeAutoLogin = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (res: TypeChangeAutoLoginResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(), onSuccess, onError);
  };

  return requestChangeAutoLogin;
};
